import React from "react";
import { Layout, theme, Typography } from "antd";
import EditMeeting from "../components/meetings/EditMeeting";
import { useLocation } from "react-router-dom";

const { Content } = Layout;

const MeetingEdit = () => {
  const location = useLocation();
  const id = location.state.id;

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            DÜZƏLİŞ ET
          </Typography.Title>
          <EditMeeting id={id} />
        </div>
      </Content>
    </Layout>
  );
};

export default MeetingEdit;
